import SettingTab from "./settingTab.container";

export default SettingTab;
